import React from 'react';
import './style.scss';
import Button from '../../../../controls/button';
import useUserData from '../../../../../contexts/userData';
import useWeb3 from '../../../../../contexts/web3';
import CreamCan from '../../../../../assets/images/common/creamCan';
import { useNavigate } from 'react-router-dom';

const LandingCreamSection = () => {
  const navigate = useNavigate();
  const { handleMetamaskClick } = useWeb3();
  const { login, loggedIn, loginLoading } = useUserData();

  const handleShopClick = () => {
    if (loggedIn) {
      navigate('/creamshop/buy');
    } else {
      handleMetamaskClick(() => login('/creamshop/buy'), 'login/signup');
    }
  };

  return (
    <section id='cream' className='landing-cream-section'>
      <div className='landing-cream-rays'>
        <img
          src='../../../../../assets/images/landing/cream_page/rays.png'
          className='rays-pc'
        />
        <img
          src='../../../../../assets/images/landing/cream_page/rays_mobile.png'
          className='rays-mobile'
        />
      </div>
      <div className='landing-cream-cat'>
        <img src='../../../../../assets/images/landing/cream_page/cat.png' />
      </div>
      <div className='landing-cream-content'>
        <div className='lcc-left'>
          <CreamCan className='lcc-cream-can' />
          <ShopButton
            className='button-mobile'
            onClick={handleShopClick}
            loading={loginLoading}
          />
        </div>
        <div className='lcc-right'>
          <p className='lcc-right-block body-1'>
            Hand cream or $CREAM is a Nifty Hands game token. Players can wager
            cream over battles and spend it on nifty items.
          </p>
          <p className='lcc-right-block body-1'>
            To get some hand cream, visit the cream shop.
          </p>
          <ShopButton
            className='button-pc'
            onClick={handleShopClick}
            loading={loginLoading}
          />
        </div>
      </div>
    </section>
  );
};

interface BtnProps {
  className: string;
  onClick: () => void;
  loading: boolean;
}

const ShopButton = ({ className, onClick, loading }: BtnProps) => {
  return (
    <Button
      color='black'
      onClick={onClick}
      className={className}
      loading={loading}
    >
      Shop Now
    </Button>
  );
};

export default LandingCreamSection;
